import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "header-inner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-6 col-sm-6" }
const _hoisted_5 = { class: "header-logo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "col-6 col-sm-6" }
const _hoisted_8 = { class: "header-option" }
const _hoisted_9 = { class: "translation" }
const _hoisted_10 = { class: "header-menu toggle-site" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", {
  id: "switch-app",
  class: "el-icon-s-grid"
}, null, -1)
const _hoisted_12 = {
  id: "switch-app",
  class: "el-icon-arrow-down"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("a", { href: _ctx.homePageUrl }, [
              _hoisted_6
            ], 8, ["href"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_el_space, {
                wrap: "",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode("span", {
                    class: { active: _ctx.checkAppLanguage('en') },
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en')))
                  }, "ENG", 2)
                ]),
                _: 1
              }),
              _createVNode(_component_el_space, {
                wrap: "",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode("span", {
                    class: { active: _ctx.checkAppLanguage('sv') },
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('sv')))
                  }, "SVE", 2)
                ]),
                _: 1
              })
            ]),
            (_ctx.appsList.length)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "bottom",
                  width: 100,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("span", null, [
                        _hoisted_11,
                        _createTextVNode(_toDisplayString(_ctx.getAPRName()), 1),
                        _withDirectives(_createVNode("i", _hoisted_12, null, 512), [
                          [_vShow, _ctx.getAPRName()?.length]
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.appsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_row, {
                        key: item.name,
                        class: "app-button-layout"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "app-button",
                                onClick: ($event: any) => (_ctx.switchApps($event, item)),
                                disabled: _ctx.activeSectionKey == item.identification_key.toUpperCase()
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}